module.exports = __webpack_public_path__ + "img/slide13.994256b7.png";